import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunnerOptionalParameter,
    Handler,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import {
    Cart,
    CartResult,
    updateCart as updateCartApi,
} from "@NA/Overrides/Services/CartService";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface ADIUpdateCartResult {
    shipTo?: ShipToModel;
    updatedBillTo?: BillToModel;
    updatedShipTo?: ShipToModel;
    cart: Cart;
}

type HandlerType = CustomApiHandler<{
    cart?: Cart;
    updatedBillTo?: BillToModel;
    updatedShipTo?: ShipToModel;
} & HasOnSuccess<ADIUpdateCartResult>, ADIUpdateCartResult>;

export const DispatchBeginUpdateCart: HandlerType = props => {
    props.dispatch({
        type: "Pages/CheckoutShipping/BeginUpdateCart",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        cart: props.parameter.cart,
    };
};

export const AddOrUpdateShipTo: HandlerType = async props => {
    // TODO: Implement update ship to when selecting alternate address
};

export const UpdateBillTo: HandlerType = async props => {
    // TODO: Implement update bill to when selecting alternate address
};

export const UpdateSession: HandlerType = async props => {
    // TODO
};

export const UpdateCart: HandlerType = async props => {
    props.apiResult = await updateCartApi({
        cart: props.parameter.cart!,
    });
};

export const DispatchUpdateCartResult: HandlerType = props => {
    props.dispatch({
        type: "Data/Carts/CompleteLoadCart",
        model: props.apiResult.cart,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const DispatchCompleteUpdateCart: HandlerType = props => {
    props.dispatch({
        type: "Pages/CheckoutShipping/CompleteUpdateCart",
    });
};

export const chain = [
    DispatchBeginUpdateCart,
    PopulateApiParameter,
    AddOrUpdateShipTo,
    UpdateBillTo,
    UpdateSession,
    UpdateCart,
    DispatchUpdateCartResult,
    ExecuteOnSuccessCallback,
    DispatchCompleteUpdateCart,
];

const adiUpdateCart = createHandlerChainRunnerOptionalParameter(chain, {}, "ADIUpdateCart");
export default adiUpdateCart;
